import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee06568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Benefits", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle" }, " Below are the benefit plans available to you. To enroll in a plan, click Enroll. A summary of the coverage options will appear, along with the effective date and monthly payment amount. To forgo a benefit plan, click Waive and you will not be enrolled in that plan. Once you've made your selections, click SAVE & NEXT to move to the next step. Please add the dependents you want to enroll in benefit(s) or update any existing dependents’ information. ", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "accordion-header collapsed" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "insurance-form" }
const _hoisted_13 = { class: "coverage-details" }
const _hoisted_14 = { class: "coverage-info" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Effective Date Of Coverage:", -1))
const _hoisted_17 = { class: "info-value text-number" }
const _hoisted_18 = { class: "coverage-info" }
const _hoisted_19 = { class: "info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Carrier:", -1))
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefit-title" }, "Coverage Options", -1))
const _hoisted_23 = {
  key: 0,
  class: "coverage-options"
}
const _hoisted_24 = { class: "option single-type" }
const _hoisted_25 = { class: "option-price" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_27 = { class: "effective-rate-coverage" }
const _hoisted_28 = { class: "effective-date" }
const _hoisted_29 = { class: "effective-rate" }
const _hoisted_30 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_32 = { class: "effective-rate" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "coverage-options"
}
const _hoisted_35 = { class: "option single-type" }
const _hoisted_36 = { class: "option-price" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_38 = { class: "effective-rate-coverage" }
const _hoisted_39 = { class: "effective-date" }
const _hoisted_40 = { class: "effective-rate" }
const _hoisted_41 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_43 = { class: "effective-rate" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_45 = {
  key: 2,
  class: "coverage-options"
}
const _hoisted_46 = { class: "option-title" }
const _hoisted_47 = { class: "option-price" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_49 = { class: "effective-rate-coverage" }
const _hoisted_50 = { class: "effective-date" }
const _hoisted_51 = { class: "effective-rate" }
const _hoisted_52 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_54 = { class: "effective-rate" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_56 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefit-title" }, "Who Does This Plan Need To Cover?", -1))
const _hoisted_59 = { class: "plan-coverage" }
const _hoisted_60 = { class: "person" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-check-label",
  for: "self"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    class: "form-check-input",
    id: "self",
    checked: "",
    disabled: ""
  })
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, null, -1))
const _hoisted_63 = { class: "person-details" }
const _hoisted_64 = { class: "person-name" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "person-subtext" }, "You", -1))
const _hoisted_66 = {
  class: "form-check-label",
  for: "self"
}
const _hoisted_67 = ["onUpdate:modelValue", "id", "onChange", "disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, null, -1))
const _hoisted_69 = { class: "person-details" }
const _hoisted_70 = { class: "person-name" }
const _hoisted_71 = { class: "person-subtext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.validationMsg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: benefit.planDescription,
          class: _normalizeClass(["accordion", {
        active: benefit.isOpen,
        enrolled: benefit.isWaived === false,
      }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.toggleAccordionOpen(index)),
              class: _normalizeClass(["title", { waived: benefit.isWaived === true }])
            }, _toDisplayString(benefit.planDescription), 11, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(["enroll-button", { active: benefit.isWaived === false }]),
                onClick: ($event: any) => (_ctx.toggleAccordion(index, _ctx.action.enroll))
              }, " Enroll ", 10, _hoisted_8),
              _createElementVNode("button", {
                class: _normalizeClass(["waive-button", { active: benefit.isWaived === true }]),
                onClick: ($event: any) => (_ctx.toggleAccordion(index, _ctx.action.waive))
              }, " Waive ", 10, _hoisted_9)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["arrow no-btn", {
            collapsed: !benefit.isOpen,
          }]),
              "aria-label": "arrow",
              onClick: ($event: any) => (_ctx.toggleAccordionOpen(index))
            }, null, 10, _hoisted_10)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-content collapse", { show: benefit.isOpen, collapse: !benefit.isOpen }]),
            id: 'flush-' + benefit.benefitId
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.effectiveDate(benefit.benefitEndDate)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(benefit.carrierName), 1)
                  ])
                ])
              ]),
              _hoisted_22,
              (benefit.benefitRateTypeId === _ctx.common.benefit.single)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(benefit.singleMonthlyPremiumRate)) + "/", 1),
                        _hoisted_26
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.singleRates, (singleRate, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(singleRate.effectiveDate!)), 1),
                            _createElementVNode("div", _hoisted_29, " $" + _toDisplayString(_ctx.helper.formatNumber(singleRate.monthlyPremiumRate!)), 1)
                          ]),
                          (singleRate.subsidyAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        singleRate.subsidyAmount < 0
                          ? singleRate.subsidyAmount * -1
                          : singleRate.subsidyAmount
                      )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_33
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (benefit.benefitRateTypeId === _ctx.common.benefit.unique)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(benefit.uniqueMonthlyPremiumRate)) + "/", 1),
                        _hoisted_37
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.uniqueRates, (uniqueRate, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(uniqueRate.effectiveDate!)), 1),
                            _createElementVNode("div", _hoisted_40, " $" + _toDisplayString(_ctx.helper.formatNumber(uniqueRate.monthlyPremiumRate!)), 1)
                          ]),
                          (uniqueRate.subsidyAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("div", _hoisted_43, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        uniqueRate.subsidyAmount < 0
                          ? uniqueRate.subsidyAmount * -1
                          : uniqueRate.subsidyAmount
                      )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_44
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (benefit.benefitRateTypeId === _ctx.common.benefit.tier)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.coverageOptions, (option, optionIndex) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: _normalizeClass(["option", { active: option.isSelected }]),
                        key: 'option-' + option.tierCodeId
                      }, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(option.tierLevelName), 1),
                        _createElementVNode("div", _hoisted_47, [
                          _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(option.monthlyPremiumRate!)) + "/", 1),
                          _hoisted_48
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.tierRates, (tierRate) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'tierrate-' + tierRate.employeeRate
                          }, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(tierRate.effectiveDate!)), 1),
                              _createElementVNode("div", _hoisted_51, " $" + _toDisplayString(_ctx.helper.formatNumber(tierRate.monthlyPremiumRate!)), 1)
                            ]),
                            (tierRate.subsidyAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _hoisted_53,
                                  _createElementVNode("div", _hoisted_54, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        tierRate.subsidyAmount < 0
                          ? tierRate.subsidyAmount * -1
                          : tierRate.subsidyAmount
                      )), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_55
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: 'member-' + option.tierCodeId + '-' + benefit.benefitId,
                          "onUpdate:modelValue": ($event: any) => ((option.isSelected) = $event),
                          onChange: ($event: any) => (
                  _ctx.tierSelected(
                    option.isSelected!,
                    option.tierRate!,
                    benefit.benefitId!,
                    benefit.planDescription!,
                    index,
                    optionIndex
                  )
                )
                        }, null, 40, _hoisted_56), [
                          [_vModelCheckbox, option.isSelected]
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (benefit.dependentValMsg)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "dependent-val-msg",
                    innerHTML: benefit.dependentValMsg
                  }, null, 8, _hoisted_57))
                : _createCommentVNode("", true),
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("label", _hoisted_60, [
                  _hoisted_61,
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.profile.firstName) + " " + _toDisplayString(_ctx.profile.lastName), 1),
                    _hoisted_65
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.dependents, (dependent) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "person",
                    key: 'dependent-' + dependent.electionDependentId
                  }, [
                    _createElementVNode("div", _hoisted_66, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((dependent.isSelected) = $event),
                        type: "checkbox",
                        class: "form-check-input",
                        id: 
                    'dependent-' +
                    dependent.electionDependentId +
                    '-' +
                    benefit.benefitId
                  ,
                        onChange: ($event: any) => (
                    _ctx.changeDependent(
                      dependent.isSelected!,
                      index,
                      dependent.relationshipName!
                    )
                  ),
                        disabled: dependent.disabled
                      }, null, 40, _hoisted_67), [
                        [_vModelCheckbox, dependent.isSelected]
                      ])
                    ]),
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, _toDisplayString(dependent.firstName) + " " + _toDisplayString(dependent.lastName), 1),
                      _createElementVNode("div", _hoisted_71, _toDisplayString(dependent.relationshipName), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 10, _hoisted_11)
        ], 2))
      }), 128))
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.common.saveNext,
      "is-form-invalid": _ctx.isBenefitNotValid(),
      "is-submit-disabled": false,
      onSubmitHandler: _ctx.submitHandler,
      "tool-tip": _ctx.benefitsValidationMessage
    }, null, 8, ["save-btn-txt", "is-form-invalid", "onSubmitHandler", "tool-tip"])
  ], 64))
}